import { saveAs } from 'file-saver';

function fileExporter(fileName, text) {
  var blob = new Blob([text], {type: "text/plain;charset=utf-8"});
  saveAs(blob, fileName);
}

export default fileExporter
